< !--template for the modal component-- >
<template>
    <transition name="listado">
        <div class="listado-mask">
            <div class="listado-wrapper">
                <div class="listado-container">

                    <div class="listado-header">
                        <slot name="header">
                            <h2>Listado de autorizaciones</h2>
                        </slot>
                    </div>
                    <hr />
                    <div class="listado-body">
                        <slot name="body">
                            default
                        </slot>
                    </div>
                    <hr />
                    <div class="listado-footer">
                        <slot name="footer">
                            default
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    module.exports = {
        name: "integrantesmodal",
        data: function () {
            return {
                showIntegrante: false,
            }
        },
    }
</script>

<style>

    .listado-mask {
        position: fixed;
        z-index: 9999;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .listado-wrapper {
        display: table-cell;
        vertical-align: middle;
        width: inherit;
    }

    .listado-container {
        width: 55%;
        border-right-width: thin;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }


    .listado-header h2 {
        margin-top: 0;
        color: #428bca;
    }

    .listado-body {
        margin: 20px 0;
        overflow-x: auto;
    }

    @media screen and (max-height: 380px) {
        .listado-body {
            height: 140px;
            overflow-x: auto;
            overflow-y: auto;
        }
    }

    .listado-footer {
        text-align: right;
    }

    .listado-enter {
        opacity: 0;
    }

    .listado-leave-active {
        opacity: 0;
    }

    .listado-enter .listado-container,
    .listado-leave-active .listado-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* Large desktop */
    @media (min-width: 1200px) {
        .listado-container {
            width: 55%;
        }
    }

    /* Portrait tablet to landscape and desktop */
    @media (min-width: 768px) and (max-width: 979px) {
        .listado-container {
            width: inherit;
            margin: 0px !important;
        }
    }

    /* Landscape phone to portrait tablet */
    @media (min-width: 480px) and (max-width: 767px) {
        .listado-container {
            width: inherit;
            margin: 0px !important;
        }
    }

    /* Landscape phones and down */
    @media (max-width: 480px) {
        .listado-container {
            width: inherit;
            margin: 0px !important;
        }
    }

</style>



// WEBPACK FOOTER //
// Scripts/js/components/modalListadoAut.vue